import { useMutation } from "@tanstack/react-query";

import { ApiError } from "@config/apiClient";
import { queryClient } from "@config/queryClient";
import useEmailStore from "@store/useEmailStore";
import emailService from "@services/email.service";
import useSystemStore from "@store/useSystemStore";
import ToastService from "@services/toast.service";
import { ERROR_STRINGS, ERROR_MESSAGES } from "@config/messages";
import { useBugsnagErrorHandler } from "@hooks/useBugsnagErrorHandler";
import { DisconnectedError } from "@app-types/errors";
import { ActiveScreen } from "@enums/screens.enum";
import { THREAD_QUERY_KEY, REMOVE_THREAD_MUTATION_KEY } from "@config/query";

export function useRemoveThread() {
  const { notifyBugsnag } = useBugsnagErrorHandler();
  const { changeActiveScreen } = useSystemStore();
  const { threadId, setEmailId, setThreadId } = useEmailStore();

  return useMutation({
    mutationKey: [REMOVE_THREAD_MUTATION_KEY],
    mutationFn: async () => {
      return await emailService.removeThread(threadId);
    },
    onSuccess: (response) => {
      setEmailId(null);
      setThreadId(null);
      changeActiveScreen(ActiveScreen.SYNC_EMAIL);

      queryClient.removeQueries({ queryKey: [THREAD_QUERY_KEY, threadId] });

      ToastService.showSuccess("Thread Successfully Removed");
      ToastService.dismiss("sync-when-sent");
    },
    onError: (error) => {
      if (error instanceof DisconnectedError) return;
      notifyBugsnag(error, ERROR_STRINGS.REMOVE_THREAD);
      ToastService.showError(error as ApiError, ERROR_MESSAGES.REMOVE_THREAD);
    },
  });
}
